import React, { useState } from 'react';
import { doc, updateDoc, arrayUnion, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { uploadPhotos } from '../../firebase/storageService';
import { COLORS } from '../../styles/tokens';
import { isCarrierOrder } from '../../utils/carrierOrder';

// Statuser der sjåføren kan legge til bilder i etterkant. Etter at bestiller har bekreftet er oppdraget låst.
export const LATE_ADDITION_STATUSES = ['in_progress', 'delivered_pending'];
const MAX_PER_BATCH = 5;

// «Legg til bilde» etter henting og levering. Statusen endres ikke; bildene havner på tidslinjen
// med tidspunkt og teksten «lagt til i etterkant».
export default function LateAdditions({ order }) {
  const [busyStage, setBusyStage] = useState(null);
  const [error, setError] = useState('');
  if (!order || !LATE_ADDITION_STATUSES.includes(order.status)) return null;

  const stages = [{ stage: 'pickup', label: 'Legg til bilde fra henting' }];
  if (order.status === 'delivered_pending' || order.deliveredAt) stages.push({ stage: 'delivery', label: 'Legg til bilde fra levering' });

  async function onPick(stage, e) {
    const files = Array.from(e.target.files ?? []).slice(0, MAX_PER_BATCH);
    e.target.value = '';
    if (!files.length) return;
    setBusyStage(stage);
    setError('');
    try {
      const urls = await uploadPhotos(files, `deliveries/${order.id}/late/${stage}`);
      await updateDoc(doc(db, 'orders', order.id), {
        lateAdditions: arrayUnion({ stage, urls, addedAt: Timestamp.now() }),
      });
    } catch (err) {
      console.error(err);
      setError('Kunne ikke legge til bildene. Oppdraget kan være bekreftet av bestiller, eller du mangler nett. Prøv igjen.');
    } finally {
      setBusyStage(null);
    }
  }

  return (
    <div style={styles.wrap}>
      {stages.map(({ stage, label }) => (
        <label key={stage} style={{ ...styles.btn, ...(busyStage ? styles.disabled : {}) }}>
          {busyStage === stage ? 'Laster opp…' : `📷 ${label}`}
          <input type="file" accept="image/*" multiple disabled={!!busyStage} onChange={e => onPick(stage, e)} style={{ display: 'none' }} />
        </label>
      ))}
      <p style={styles.hint}>Kan legges til helt til {isCarrierOrder(order) ? 'ordren er fullført' : 'bestiller har bekreftet leveringen'}. Bildene vises på tidslinjen som lagt til i etterkant.</p>
      {error && <p role="alert" style={styles.error}>{error}</p>}
    </div>
  );
}

const styles = {
  wrap:     { display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 },
  btn:      { display: 'block', textAlign: 'center', padding: '12px 8px', borderRadius: 26, border: `2px solid ${COLORS.primary}`, background: COLORS.white, color: COLORS.textDark, fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  disabled: { opacity: 0.5, cursor: 'not-allowed' },
  hint:     { fontSize: 12, color: COLORS.textLight, margin: '2px 4px 0', lineHeight: 1.4 },
  error:    { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '8px 12px', borderRadius: 10, fontSize: 13, margin: 0 },
};
